import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { TopReels } from './components/TopReels';
import { PresentationMockup } from './components/PresentationMockup';
import { Footer } from '../_shared/Footer';

export default function SourceLabReport1() {
    useEffect(() => {
        const pageTitle = 'Source Code Lab – 60-Day Snapshot (Mar–Apr 2026) | SocialSEO';
        document.title = pageTitle;

        const ensureMeta = (selector, attributes) => {
            let el = document.querySelector(selector);
            if (!el) {
                el = document.createElement('meta');
                Object.entries(attributes).forEach(([k, v]) => el.setAttribute(k, v));
                document.head.appendChild(el);
            }
            el.setAttribute('content', pageTitle);
        };

        ensureMeta('meta[property="og:title"]', { property: 'og:title' });
        ensureMeta('meta[name="twitter:title"]', { name: 'twitter:title' });
    }, []);

    return (
        <div className="font-sans leading-relaxed text-white relative" style={{ fontFamily: "'Plus Jakarta Sans', Inter, sans-serif" }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');
            `}</style>

            <header className="fixed top-0 left-0 right-0 z-50 p-4 md:p-6 flex justify-between items-center bg-transparent pointer-events-none">
                <div className="bg-white/10 backdrop-blur-lg border border-white/10 px-4 py-2 rounded-full pointer-events-auto">
                    <span className="font-bold tracking-tight text-cyan-300">
                        <span className="text-white">Social</span>SEO
                    </span>
                </div>
                <div className="bg-white/10 backdrop-blur-lg border border-white/10 px-4 py-2 rounded-full pointer-events-auto">
                    <span className="text-sm font-medium text-white/80">Mar 1 – Apr 30, 2026</span>
                </div>
            </header>

            <div className="relative z-10">
                <main>
                    <HeroSection />
                    <TopReels />
                    <PresentationMockup />
                </main>

                <Footer />
            </div>
        </div>
    );
}
